import React from 'react'
import propTypes from 'prop-types'

const TextScroll = ({ Text }) => {

    return (
        <div className="info-banner">
          <div className="marquee">
            <span className='marquee-span'>{Text}</span>
          </div>
        </div>
      )
}

TextScroll.propTypes = {
    Text: propTypes.string.isRequired
}

export default TextScroll